export const LegacyStringMap = {
  Grid_Edit_Cell: _TL_('Edit cell of column {{columnName}} and row {{rowIndex}}'),
  'Select all': _TL_('Select all'),
  'Deselect all': _TL_('Deselect all'),
  'Select this row': _TL_('Select this row'),
  'Deselect this row': _TL_('Deselect this row'),
};
